import {
    Button,
    Chip,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid2,
    Badge,
    IconButton,
    Radio,
    RadioGroup,
    Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { lighten } from "@mui/system";

import log from "loglevel";
import React, { useEffect, useState } from "react";

import AddIcon from "@mui/icons-material/Add";
import CheckIcon from "@mui/icons-material/Check";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import PostAddOutlinedIcon from "@mui/icons-material/PostAddOutlined";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import SelectAllOutlined from "@mui/icons-material/SelectAllOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import classnames from "classnames";
import ConfirmDialog from "components/common/ConfirmDialog";
import { ErrorOutlinedButton, ErrorTextButton } from "components/common/CustomButtons";
import LoadingFullScreen from "components/common/LoadingFullScreen";
import { FilmCardView } from "components/film";
import { actions as reportActions } from "components/report/advertising/logic/advReportActions";
import { actions as reportLogActions } from "components/report/logsheet/logic/logReportActions";
import { isLoadingStatus } from "core/actions";
import { getStatusColorById } from "core/dataConstants";
import { assertObject, assertString } from "core/validation";
import { get } from "lodash";
import PropTypes from "prop-types";
import {connect, useDispatch, useSelector} from "react-redux";
import { toast } from "react-toastify";
import AdvertisingService from "services/advertisingService";
import Select from "../common/Select";
import "./commonComponents.scss";
import { SelectedAdvSelector, actions } from "./logic/formActions";
import {assertArray} from "core/validation";
import AdvertisementCloneDialog from "components/advertising/AdvertisementCloneDialog";
import {DATE_FORMAT_FULL_INPUT, formatDate} from "components/common/dateUtils";
import {handleServerErrors} from "core/exceptions";
import { isReadOnlyRole } from "../login/logic/sagas";
import { currentUserSelector } from "../login/logic/actions";

export function AdvExpandHeader({ adv, attrLength, final, attrLEQ }) {
    const classes = useToolbarStyles();
    return (
        (<div style={{paddingLeft: 10}} className={classes.panelSummary}>
            <Grid2 container>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 8,
                        lg: 6,
                        xl: 6
                    }}>
                    <Typography style={{ fontWeight: 600 }}>{adv.name}</Typography>
                    <div className={classes.panelSummaryContent}>
                        <Typography>
                            {adv.advertisementType ? adv.advertisementType.name : ""}
                            <span style={{ marginLeft: 10 }}>
                                {attrLength && ` Length:  ${attrLength ? attrLength.attributeValue + " sec" : ""}`}
                                {}
                                {}
                                {}
                                {}
                                {}
                                {}
                                {attrLEQ && <span style={{ paddingLeft: 20 }}>LEQ: {attrLEQ.attributeValue}</span>}
                                <span style={{ paddingLeft: 20 }}>QTY: {adv.quantity || 1}</span>
                            </span>
                        </Typography>
                    </div>
                </Grid2>
                <Grid2
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 4,
                        lg: 6,
                        xl: 6
                    }}>
                    <div className={classes.panelSummaryContent}>
                        {final && (
                            <Chip
                                variant="outlined"
                                size="small"
                                icon={<CheckIcon />}
                                label={"Final"}
                                color={"secondary"}
                            />
                        )}
                        <Chip
                            variant="outlined"
                            style={{ marginLeft: 10 }}
                            size="small"
                            color={adv.reported ? "primary" : "default"}
                            icon={adv.reported ? <CheckIcon /> : null}
                            label={adv.reported ? "Reported" : "Unreported"}
                        />
                        {adv.exception && (
                            <Chip
                                style={{ marginLeft: 10 }}
                                variant="outlined"
                                size="small"
                                icon={<ReportProblemIcon className={classes.exceptionIcon} />}
                                label={"Exception"}
                                className={classes.exceptionChip}
                            />
                        )}
                    </div>
                </Grid2>
            </Grid2>
        </div>)
    );
}
export const StatusIcon = ({ style, status }) => {
    const status_color = status && status.id ? getStatusColorById(status.id) : "grey";
    const _Style = Object.assign({}, style, { color: status_color });
    const hasStatusName = assertString(status.name);
    return hasStatusName ? <FiberManualRecordIcon style={_Style} /> : null;
};
export function ReviewExpandHeader({ review, status, dateEntered, dateModified }) {
    const classes = useToolbarStyles();

    const statusName = status ? status.name : "No Status";
    const viewers = review?.viewers || [];
    log.debug("[REVIEW EXPAND HEADER]: status", status, dateEntered, dateModified);
    return (
        <div className={classes.panelSummary}>
            <div className={classes.panelSummaryTitle}>
                <div className={classes.panelSummaryContent}>
                    <StatusIcon status={status} />
                    <Typography style={{ fontWeight: 600, paddingRight: 10 }}>{statusName}</Typography>
                </div>
                <div className={classes.panelSummaryContent}>
                    {dateEntered && (
                        <Typography>
                            Date Created: <b>{formatDate(dateEntered, DATE_FORMAT_FULL_INPUT)}</b>
                        </Typography>
                    )}
                </div>
            </div>
            <div className={classes.panelSummarySubTitle}>
                <div className={classes.panelSummaryContent}></div>
                <div className={classes.panelSummaryContent}>
                    {dateModified && (
                        <Typography>
                            Last Modified:<b> {formatDate(dateModified, DATE_FORMAT_FULL_INPUT)}</b>
                        </Typography>
                    )}
                </div>
            </div>
            {viewers.length > 0 && <div className={classes.panelSummarySubTitle}>
                <div className={classes.panelSummaryContent}></div>
                <div className={classes.panelSummaryContent}>
                    <Typography className={classes.selectViewersContent}>
                        <span className={classes.selectViewersTitle}>
                            Viewers:
                        </span>
                        <b className={classes.selectViewersList}>
                            {viewers.map(viewer => viewer.name).join(", ")}
                        </b>
                    </Typography>
                </div>
            </div>}
        </div>
    );
}

ReviewExpandHeader.propTypes = {
    review: PropTypes.object,
    status: PropTypes.object,
    dateEntered: PropTypes.string,
    dateModified: PropTypes.string,
};

export function FilmCardV({defaultExpanded=false,...props}) {
    return <FilmCardView  defaultExpanded={defaultExpanded} {...props} />;
}

const mapStateToProps = ({ advertising }) => ({
    loadFilmReleaseId: advertising.form.filmRelease ? advertising.form.filmRelease.id : null,
});

export const FilmCard = connect(mapStateToProps)(FilmCardV);

export function RadioBtnGroup(props) {
    return (
        <FormControl style={{ paddingLeft: 10 }} component="fieldset">
            <FormLabel component="legend">{props.label}</FormLabel>
            <RadioGroup
                aria-label="gender"
                name={props.name}
                defaultValue={props.defaultValue || 0}
                onChange={props.onChange}
            >
                {props.options.map((option) => (
                    <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio />}
                        label={option.label}
                    />
                ))}
            </RadioGroup>
        </FormControl>
    );
}

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === "light"
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    button: {
        marginRight: theme.spacing(2),
        padding: 8,
    },
    panelSummary: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
    },
    panelSummaryTitle: {
        display: "flex",
        flex: 1,
    },
    panelSummarySubTitle: {
        display: "flex",
        flex: 1,
    },
    panelSummaryContent: {
        display: "flex",
        flex: 1,
        paddingTop: 3,
    },
    selectViewersTitle: {
        paddingRight: 10
    },
    selectViewersContent: {
        display: "flex",
        flex: 1
    },
    selectViewersList: {
        width: "90%"
    },
    plusBtn: {
        marginLeft: "20px",
        order: 2,
    },
    iconColor: {
        color: theme.palette.secondary.main,
    },
    exceptionChip: {
        borderColor: theme.palette.error.main,
        color: theme.palette.error.main,
    },
    exceptionIcon: {
        color: theme.palette.error.main,
    },
}));

function EnhancedTableToolbarV({
                                   numSelected,
                                   orderByFields,
                                   onSelectField,
                                   orderBy,
                                   order,
                                   onRefresh,
                                   onChangeExpanded,
                                   expandAllRows,
                                   toggleGlobalSelection,
                                   globalSelectionMode,
                                   toggleAdvertisingForm,
                                   addingGlobalReportStatus,
                                   onAddGlobalReport,
                                   onAddGlobalLogReport,
                                   filmId,
                                   noSelection = false,
                                   ...props
                               }) {
    const classes = useToolbarStyles();

    const [selectionMode, setSelectionMode] = useState(globalSelectionMode);
    const [alreadyOrdered, setAlreadyOrdered] = useState(false);
    const showFilm = assertObject(filmId);
    const isAdvReportLoading = isLoadingStatus(addingGlobalReportStatus);
    const user = useSelector(currentUserSelector);

    useEffect(() => {
        if (globalSelectionMode !== selectionMode) {
            setSelectionMode(globalSelectionMode);
        }
    }, [globalSelectionMode, selectionMode]);

    const fields = orderByFields.filter((field) => field.label);

    const hasSelection =
        selectionMode === 1 ||
        globalSelectionMode === 1 ||
        selectionMode === -1 ||
        globalSelectionMode === -1 ||
        numSelected > 0;

    function handleToggleSelection() {
        toggleGlobalSelection();
    }
    function handleAddToReport() {
        if (!isAdvReportLoading) {
            onAddGlobalReport();
        }
    }
    function handleAddToLog() {
        if (!isAdvReportLoading) {
            onAddGlobalLogReport();
        }
    }

    function handleOnAddAdv() {
        if (props.onAdd) {
            props.onAdd();
        } else {
            toggleAdvertisingForm();
        }
    }

    const Placeholder = (propsP) => {
        return (
            <div
                style={{
                    color: "#928894",
                    position: "absolute",
                    width: "97%",
                    paddingTop: 5,
                    height: "100%",
                }}
            >
                {alreadyOrdered && order === "ASC" && <ExpandLessIcon />}
                {alreadyOrdered && order === "DESC" && <ExpandMoreIcon />}
                <span style={{ width: "100%", position: "absolute", top: "7px" }}>
                    {propsP.selectProps.placeholder}
                </span>
            </div>
        );
    };

    const formatOptionLabel = (props) => {
        return (
            <div style={{ display: "flex", padding: "4px 5px", fontSize: 14 }}>
                <div style={{ display: "flex", flex: 1 }}>
                    <span style={{ fontSize: 12, marginTop: -2, paddingRight: 5 }}>
                        {orderBy === props.value && order === "ASC" && <ExpandLessIcon />}
                        {(orderBy !== props.value || order === "DESC") && <ExpandMoreIcon />}
                    </span>
                    {props.label}
                </div>
            </div>
        );
    };

    let selectCheck = <CheckBoxOutlineBlankIcon style={{ opacity: 0.7 }} />;
    if (selectionMode === 1) {
        selectCheck = <CheckBoxIcon color={"secondary"} />;
    } else if (selectionMode === -1) {
        selectCheck = <IndeterminateCheckBoxIcon style={{ opacity: 0.7 }} />;
    }
    const selectIconRender = (
        !isReadOnlyRole(user) && <Tooltip title="Select ">
            <IconButton style={{ padding: 3 }} size="small" disableRipple onClick={handleToggleSelection}>
                {selectCheck}
            </IconButton>
        </Tooltip>
    );
    const progress = <CircularProgress variant="indeterminate" disableShrink size={20} thickness={4} />;
    const selectedActions = (
        <div className="actions" style={{ display: "flex", flex: 1, justifyContent: "flex-start", gap: "10px" }}>
            {!isReadOnlyRole(user) && <CloneAdvBtn />}
            {!isReadOnlyRole(user) && <Button size={"small"} variant={"outlined"} onClick={handleAddToLog} startIcon={<PostAddOutlinedIcon />}>
                Add to Log
            </Button>}

            {showFilm && !isReadOnlyRole(user) && (
                <Button
                    size={"small"}
                    variant={"outlined"}
                    startIcon={isAdvReportLoading ? progress : <PostAddOutlinedIcon />}
                    onClick={handleAddToReport}
                >
                    Add to Report
                </Button>
            )}
            {!isReadOnlyRole(user) && <DeleteMultipleAdvBtn refreshAdvTable={onRefresh} />}
            <ResetSelectionBtn />
        </div>
    );

    const unselectedActions = (
        <div className="actions" style={{ display: "flex", flex: 1, justifyContent: "flex-start", gap: "10px"}}>
            {!isReadOnlyRole(user) && <Button
                size={"small"}
                variant={"outlined"}
                startIcon={<AddIcon />}
                className={classes.plusBtn}
                style={noSelection ? { marginLeft: 0 } : undefined}
                onClick={handleOnAddAdv}
            >
                {props.addText || "Add Advertising"}
            </Button>}
            {onChangeExpanded && (
                <Button
                    size={"small"}
                    variant={"outlined"}
                    startIcon={!expandAllRows ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    className={classes.plusBtn}
                    onClick={() => onChangeExpanded([!expandAllRows, true])}
                >
                    {!expandAllRows ? "Expand" : "Collapse"} All
                </Button>
            )}

            <Button
                size={"small"}
                variant={"outlined"}
                startIcon={<RefreshIcon className={classes.iconColor} />}
                className={classes.plusBtn}
                onClick={onRefresh}
            >
                Refresh
            </Button>
        </div>
    );
    return (
        <Toolbar className={classnames(classes.root, "table-body-toolbar")}>
            <React.Fragment>
                {!noSelection && <div className={"table-toolBar-selection"}>{selectIconRender}</div>}
                {hasSelection ? selectedActions : unselectedActions}
                <div id="table-order-selector">
                    <Select
                        options={fields.map((field) => ({
                            value: field.id,
                            label: field.label,
                        }))}
                        placeholder={<div style={{paddingLeft: 10}}>{alreadyOrdered ? fields.find((field) => field.id === orderBy).label : "Order By:"}</div>}
                        value={orderBy}
                        onChange={(e) => {
                            !alreadyOrdered && setAlreadyOrdered(true);
                            if (onSelectField) {
                                onSelectField(e, e.value);
                            }
                        }}
                        formatOptionLabel={formatOptionLabel}

                        components={{ Placeholder }}
                    />
                </div>
            </React.Fragment>
        </Toolbar>
    );
}
async function deleteAdvById(id, callback) {
    try {
        await AdvertisingService.deleteAdv(id);
        callback(true);
        return true;
    } catch (e) {
        callback(false, e);
        return false;
    }
}

async function deleteMultipleAdvById(advertisers, callback) {
    const advertiserIds = advertisers.map(a => a.id).join(",");
    try {
        await AdvertisingService.deleteMultipleAdv(advertiserIds);
        callback(true);
        return true;
    } catch (e) {
        callback(false, e);
        return false;
    }
}

export function AddNewAdvFromExisting({ advId, onClick, refreshViewPage, labelText, ...other }) {
    const dispatch = useDispatch();

    function handleOnClick() {
        if (onClick) {
            onClick();
        }
        dispatch(actions.CREATE_ADV_FROM_EXISTING.call({ id: advId, refreshViewPage, isClone: labelText === "CLONE" }));
    }
    return (
        <Button
            variant={"outlined"}
            size={"small"}
            color={"primary"}
            {...other}
            onClick={handleOnClick}
            startIcon={<AddIcon />}
        >
            {labelText || "NEW"}
        </Button>
    );
}

export function DeleteAdvBtn({ btnProps, advId, onAdvDeleted, advName }) {
    const _btnProps = Object.assign(
        {},
        {
            variant: "outlined",
            size: "small",
        },
        btnProps
    );
    const [showConfirm, setShowConfirm] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);

    function showError() {
        toast.error("There has been an error. Please try again", {
            position: "top-right"});
    }
    function deleteAdv(id) {
        deleteAdvById(id, (result, error) => {
            if (result) {
                setDeleting(false);
                onAdvDeleted();
            } else {
                setDeleting(false);
                handleServerErrors(error, () => {
                    showError();
                });

            }
        });
    }

    function handleOnClick() {
        setShowConfirm(true);
    }
    function handleClose() {
        setShowConfirm(false);
    }
    function handleDelete() {
        setShowConfirm(false);
        setDeleting(true);
        deleteAdv(advId);
    }
    const message = (
        <>
            <Typography gutterBottom variant={"subtitle1"}>
                Deleting advertising materials will also permanently remove all information related to it!
            </Typography>
            <Typography gutterBottom variant={"subtitle1"}>
                Are you sure that you want to delete <b>{advName}</b> ?
            </Typography>
        </>
    );
    return (
        <>
            <ErrorOutlinedButton {..._btnProps} onClick={handleOnClick} startIcon={<DeleteOutlineOutlinedIcon />}>
                Delete
            </ErrorOutlinedButton>
            <ConfirmDialog
                open={showConfirm}
                message={message}
                btnConfirm={<ErrorTextButton onClick={handleDelete}>Delete</ErrorTextButton>}
                closeText="Close"
                onConfirm={handleDelete}
                onCancel={handleClose}
            />
            <LoadingFullScreen open={deleting} loadingMessage={"Deleting ..."} />
        </>
    );
}

function CloneAdvBtn() {
    const [openCloneDialog, setOpenCloneDialog] = React.useState(false);
    const selectedAdv = useSelector(SelectedAdvSelector);
    const handleClone = () => {

        const firstFilmRelease = selectedAdv && selectedAdv[0].filmRelease;
        if (
            selectedAdv &&
            assertArray(selectedAdv) &&
            selectedAdv.filter((adv) => adv.filmRelease.id === firstFilmRelease.id).length === selectedAdv.length
        ) {
            setOpenCloneDialog(true);
        } else {
            toast.error("You need to select advertisements with the same film release", {
                position: "top-center"
            });
        }
    };

    return (
        <>
            <Badge badgeContent={selectedAdv.length} color={"secondary"}>
                <Button size={"small"} variant={"outlined"} onClick={handleClone} startIcon={<SelectAllOutlined />}>
                    Clone
                </Button>
            </Badge>

            {openCloneDialog && (
                <AdvertisementCloneDialog open={openCloneDialog} handleClose={() => setOpenCloneDialog(false)} />
            )}
        </>
    );
}

function DeleteMultipleAdvBtn({refreshAdvTable}) {
    const [openDeleteMultipleDialog, setOpenDeleteMultipleDialog] = React.useState(false);
    const [deletingAdvs, setDeletingAdvs] = useState(false);
    const selectedAdv = useSelector(SelectedAdvSelector);
    const dispatch = useDispatch();

    const handleCloseSelection = () => {
        dispatch(actions.CLOSE_SELECTION.call());
    };

    const handleDeleteMultiple = () => {
        if (selectedAdv && assertArray(selectedAdv)) {
            setOpenDeleteMultipleDialog(true);
        } else {
            toast.error("You need to select advertisements", {
                position: "top-center"
            });
        }
    };

    const message = (
        <>
            <Typography gutterBottom variant={"subtitle1"}>
                Are you sure that you want to delete the selected advertisements?
            </Typography>
        </>
    );

    function showError() {
        toast.error("There has been an error. Please try again", {
            position: "top-right"});
    }

    function onDeleteMultiple() {
        setOpenDeleteMultipleDialog(false);
        handleCloseSelection();
        setDeletingAdvs(true);
        deleteMultipleAdvById(selectedAdv, (result) => {
            if (result) {
                setDeletingAdvs(false);
                refreshAdvTable();
            } else {
                setDeletingAdvs(false);
                showError();
            }
        });
    }
    return (
        <>
            <Badge badgeContent={selectedAdv.length} color={"error"}>
                <Button size={"small"} variant={"outlined"} onClick={handleDeleteMultiple} startIcon={<DeleteOutlineOutlinedIcon />}>
                    Delete
                </Button>
            </Badge>

            {openDeleteMultipleDialog && (
                <ConfirmDialog
                    open={openDeleteMultipleDialog}
                    message={message}
                    btnConfirm={<ErrorTextButton onClick={onDeleteMultiple}>Delete</ErrorTextButton>}
                    closeText="Close"
                    onConfirm={onDeleteMultiple}
                    onCancel={() => setOpenDeleteMultipleDialog(false)}
                />
            )}
            <LoadingFullScreen open={deletingAdvs} loadingMessage={"Deleting ..."} />
        </>
    );
}

function ResetSelectionBtn() {
    const dispatch = useDispatch();
    const handleCloseSelection = () => {
        dispatch(actions.CLOSE_SELECTION.call());
    };
    return (
        <Button size={"small"} variant={"outlined"} onClick={handleCloseSelection}>
            Close
        </Button>
    );
}

EnhancedTableToolbarV.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


const mapDispatchToProps = (dispatch) => ({
    toggleAdvertisingForm: () => dispatch(actions.TOGGLE_ADVERTISING_FORM.send()),
    toggleGlobalSelection: () => dispatch(actions.TOGGLE_GLOBAL_SELECTION.call()),
    onAddGlobalReport: () => dispatch(reportActions.ON_ADD_GLOBAL_REPORT.send()),
    onAddGlobalLogReport: () => dispatch(reportLogActions.ON_ADD_GLOBAL_LOG_REPORT.send()),
});

export const EnhancedTableToolbar = connect(
    (state) => ({
        globalSelectionMode: state.advertising.globalSelectionMode,
        filmId: get(state.advertising, "form.filmRelease.id", null),
        addingGlobalReportStatus: state.advertising.addingGlobalReportStatus,
    }),
    mapDispatchToProps
)(EnhancedTableToolbarV);

RadioBtnGroup.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
};
